import script from "./DocumentDetails.vue?vue&type=script&lang=ts&setup=true"
export * from "./DocumentDetails.vue?vue&type=script&lang=ts&setup=true"

import "./DocumentDetails.vue?vue&type=style&index=0&id=b7d7a464&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b7d7a464"]])

export default __exports__